var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import buttonLayoutStyle from './ButtonLayoutStyle';
import { deprecatedComponentMessage } from '@cvent/carina-utils';
/** DEPRECATED */
var ButtonLayout = /** @class */ (function (_super) {
    __extends(ButtonLayout, _super);
    function ButtonLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonLayout.prototype.render = function () {
        // this component is deprecated for a while, and we are just now getting rid of it. It has been deprecated since at least 2019, but just now (2021) are we killing it.
        deprecatedComponentMessage({
            componentName: 'ButtonLayout',
            date: '2021',
            upgradeURL: 'Use <Col width="content"> instead.'
        });
        // dialog prop is included to ease transition to new 'alignStart' api. It can be removed in a future release.
        var _a = this.props, alignStart = _a.alignStart, isRtl = _a.isRtl, children = _a.children, dialog = _a.dialog;
        var styles = buttonLayoutStyle({
            alignStart: alignStart || dialog,
            isRtl: isRtl
        });
        return (_jsx("div", __assign({ css: styles.container }, { children: React.Children.map(children, function (child, index) { return (_jsx("div", __assign({ css: styles.item }, { children: child }), index)); }) }), void 0));
    };
    ButtonLayout.defaultProps = {
        alignStart: false,
        isRtl: false
    };
    return ButtonLayout;
}(React.Component));
export default ButtonLayout;
